import React from 'react';

export default function SectionCard({ title, action, children, style }) {
  return (
    <section style={{ ...styles.card, ...style }}>
      {(title || action) && (
        <div style={styles.header}>
          {title && <h2 style={styles.title}>{title}</h2>}
          {action && <div style={styles.action}>{action}</div>}
        </div>
      )}
      {children}
    </section>
  );
}

const styles = {
  card: {
    background: '#FFFFFF',
    borderRadius: 16,
    padding: 20,
    boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
  },
  title: {
    margin: 0,
    fontSize: 18,
    fontWeight: 700,
    color: '#1A1A1A',
    letterSpacing: '-0.01em',
  },
  action: {
    flexShrink: 0,
  },
};
